module.exports = __webpack_public_path__ + "static/media/accepted-bills.87ef2fb4.svg";